{
  "sampleSpacing": 2,
  "searchWindow": 30,
  "lowSpeed": 3,
  "surfaces": {
    "dry": 1,
    "paint": 0.85,
    "wet": 0.7
  },
  "wall": {
    "crashNormalSpeed": 10,
    "scrapeDecel": 6,
    "scrapeLoss": 0.3,
    "restitution": 0.15,
    "yawDamping": 0.1,
    "crashLockTicks": 45
  }
}
